import { loadingSpinnerSvg } from '@components/loading-spinner/loading-spinner'

type LoadingSpinnerProps = {
  additionalClasses?: string
}

export default function LoadingSpinner({ additionalClasses = '' }: LoadingSpinnerProps) {
  return <span className={`cmp-filterbar__loading-spinner  ${additionalClasses}`} dangerouslySetInnerHTML={{ __html: loadingSpinnerSvg }}></span>
}
